<template>
  <div class="receive-order-item tb" v-if="funcView.receive_order_list">
    <custom-tab :value="type" :list="tabList" @input="onTabChange" class="tab"></custom-tab>
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button
            v-if="(`${type}` === '1' || `${type}` === ' 3') && funcView.receive_order_register_collection"
            type="primary"
            :disabled="!tableSelect.length || !checkAuth(tableSelect, 'REGISTER_COLLECTION')"
            @click="registerCol(tableSelect, funcView.receive_order_register_collection)"
          >
            {{ funcView.receive_order_register_collection }}
          </el-button>
          <el-button
            v-if="(`${type}` === '1' || `${type}` === '3') && funcView.receive_order_apply_delay"
            type="primary"
            :disabled="!tableSelect.length || !checkAuth(tableSelect, 'DELAY_COLLECTION')"
            @click="onDelayDialog(tableSelect)"
          >
            {{ funcView.receive_order_apply_delay }}
          </el-button>
          <el-button v-if="funcView.receive_order_apply_invoice" type="primary" :disabled="!tableSelect.length || !checkAuth(tableSelect, 'INVOICE')" @click="onInvoiceApply(tableSelect, false)">
            {{ funcView.receive_order_apply_invoice }}
          </el-button>
          <el-button v-if="type === '3'" type="primary" :disabled="!isChangeState" @click="onApplyChangeState">{{ $t('fms_receive_order_item.bian_geng_zhuang_tai') }}</el-button>
          <el-button
            v-if="(`${type}` === '1' || `${type}` === '3') && funcView.receive_order_apply_free"
            type="primary"
            :disabled="!tableSelect.length || !checkAuth(tableSelect, 'APPLY_FREE')"
            @click="applyFree(tableSelect, funcView.receive_order_apply_free, false)"
          >
            {{ funcView.receive_order_apply_free }}
          </el-button>
          <el-button v-if="funcView.apply_red_invoice" type="primary" :disabled="!isApplyGoRed" @click="onApplyGoRed">
            {{ funcView.apply_red_invoice }}
          </el-button>
          <el-button v-if="funcView.receive_order_accessory" type="primary" :disabled="!isAccessory" @click="onAccessory">+ {{ funcView.receive_order_accessory }}</el-button>
        </el-form-item>
        <!-- 导出excel -->
        <el-form-item style="float: right; margin-right: 0" v-if="funcView.receive_order_export_excel">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable"><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right" :class="!funcView.receive_order_export_excel ? 'mr-0' : ''">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.keyword" :placeholder="$t('fms_receive_order_item.htbhsghthjsh')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <!-- 更多搜索 -->
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
        <el-form-item style="float: right" v-if="isJVSC">
          <el-radio-group v-model="formSearch.receivableOrgType" @change="onPageChange({ page: 1 })">
            <el-radio-button label="">{{ $t('Common.com_all') }}</el-radio-button>
            <el-radio-button label="JV">{{ $t('fms_receive_order_item.ying_shou_ke_hu') }}</el-radio-button>
            <el-radio-button label="SC">{{ $t('fms_receive_order_item.ying_shou_fu_wu') }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('fms_receive_order_item.xiang_mu')">
          <el-input v-model="formSearch.locationName" :placeholder="$t('fms_receive_order_item.xiang_mu')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_receive_order_item.fu_kuan_gong_si')">
          <el-input v-model="formSearch.payableOrgName" :placeholder="$t('fms_receive_order_item.fu_kuan_gong_si')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_receive_order_item.fu_kuan_dao_qi_ri_qi')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.billPaymentTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :init-value="formSearch.initBillPaymentTime"
            :key="billPaymentTimeKey"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_receive_order_item.qrskrq')" v-if="`${type}` !== '1'">
          <custom-date-picker style="width: 100%" v-model="formSearch.finalPaymentTime" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_receive_order_item.yhskrq')">
          <custom-date-picker style="width: 100%" v-model="formSearch.tradeConfirmTime" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
        <div class="half-content">
          <el-form-item :label="$t('fms_receive_order_item.she_bei_hao')" class="half-width">
            <el-input v-model="formSearch.deviceNo" :placeholder="$t('fms_receive_order_item.she_bei_hao')" type="number" :maxlength="1" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('fms_receive_order_item.qi_hao')" class="half-width">
            <el-input v-model="formSearch.termNum" :placeholder="$t('fms_receive_order_item.zhi_chi_qu_jian_ru25')" clearable></el-input>
          </el-form-item>
        </div>
        <el-form-item :label="$t('fms_receive_order_item.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%" :placeholder="$t('fms_receive_order_item.chan_pin_xing_hao')"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('fms_receive_order_item.fa_piao_hao_ma')">
          <el-input :placeholder="$t('fms_receive_order_item.fa_piao_hao_ma')" v-model="formSearch.invoiceNum" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_receive_order_item.kai_piao_zhuang_tai')">
          <custom-select v-model="formSearch.invoiceState" code="bill_invoice_show_status" :placeholder="$t('fms_receive_order_item.kai_piao_zhuang_tai')"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('fms_receive_order_item.kai_piao_shi_jian')">
          <custom-date-picker style="width: 100%" v-model="formSearch.invoiceTime" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_receive_order_item.ye_wu_yuan')">
          <el-input clearable v-model="formSearch.salesman" :placeholder="$t('fms_receive_order_item.ye_wu_yuan')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_receive_order_item.zzysrq')">
          <custom-date-picker style="width: 100%" v-model="formSearch.finalTime" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="customTb1"
        type="checkbox"
        height="100%"
        v-model="tableSelect"
        :data="tableList"
        :column="tableColumn"
        @sort="sortChange"
        @filter="filterChange"
        :clickSelection="true"
        :slots="['contractNo', 'termNum', 'sharingClasses', 'invoiceAmount', 'lockInvoiceAmount', 'action']"
      >
        <template v-slot:contractNo="scope">
          <div class="cell-link" @click.stop="toContractDetail(scope.row)">
            {{ scope.row.contractNo }}
          </div>
        </template>
        <!--  已开票金额 -->
        <template v-slot:invoiceAmount="scope">
          <span v-if="funcView.receive_order_check_invoice && checkAuth(scope.row, 'CHECK_INOVIE')" class="underline" @click.stop="checkInvoiceDetail(scope.row)">{{ scope.row.invoiceAmount }}</span>
          <span v-else>{{ scope.row.invoiceAmount }}</span>
        </template>
        <template v-slot:termNum="scope">
          <div>{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
        </template>
        <template v-slot:sharingClasses="scope">
          <div>{{ scope.row.sharingClasses ? Array.from(new Set(scope.row.sharingClasses.split(','))).join(',') : '-' }}</div>
        </template>
        <template v-slot:action="scope">
          <!-- 收款详情 -->
          <div>
            <el-button type="text" size="mini" v-if="funcView.receive_order_check_collection && checkAuth(scope.row, 'CHECK_COLLECTION_INFO')" @click.stop="onCheckCollectionRecords(scope.row)">
              {{ funcView.receive_order_check_collection }}
            </el-button>
          </div>
          <!-- 确认收款 -->
          <div>
            <el-button
              v-if="funcView.receive_order_confirm_collection && checkAuth(scope.row, 'CONFIRM_COLLECTION')"
              type="text"
              size="mini"
              @click.stop="confirmCol(scope.row, funcView.receive_order_confirm_collection)"
            >
              {{ funcView.receive_order_confirm_collection }}
            </el-button>
          </div>
          <!-- 登记收款 -->
          <div>
            <el-button
              v-if="funcView.receive_order_register_collection && checkAuth(scope.row, 'REGISTER_COLLECTION')"
              type="text"
              size="mini"
              @click.stop="registerCol(scope.row, funcView.receive_order_register_collection)"
            >
              {{ funcView.receive_order_register_collection }}
            </el-button>
          </div>
          <!-- 撤销收款 -->
          <div>
            <el-button type="text" size="mini" v-if="funcView.receive_order_cancel_collection && checkAuth(scope.row, 'CANCEL_COLLECTION')" @click.stop="onRevokeDialog(scope.row)">
              {{ funcView.receive_order_cancel_collection }}
            </el-button>
          </div>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <accounts-footer-sum :data="tableSelect" :totalPaymentAmount="totalData.totalPaymentAmount"></accounts-footer-sum>
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 延期收款/撤销收款 -->
    <approval-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList" dialogWidth="1500px"></approval-dialog>
    <!-- 确认收款 -->
    <accounts-confirm-dialog
      :model="confirmCollectionModel"
      v-if="confirmCollectionVisible"
      @close="confirmCollectionVisible = false"
      @success="getTableList"
      :rejectCollection="rejectCollection"
    ></accounts-confirm-dialog>
    <!-- 登记收款 -->
    <accounts-registration-dialog
      :model="registerCollectionModel"
      v-if="registerCollectionVisible"
      @close="registerCollectionVisible = false"
      @success="getTableList"
      @toConfirm="onToConfirm"
      :cancelRegister="cancelRegister"
      :addBill="addBill"
      :delBill="delBill"
      :addTradeMsg="addTradeMsg"
      :editTradeMsg="editTradeMsg"
      :delTradeMsg="delTradeMsg"
      :accountManage="!!funcView.receive_order_account_manage"
    ></accounts-registration-dialog>
    <!-- 查看收款信息 -->
    <accounts-collection-detail-dialog :model="dialogModel7" v-if="dialogVisible7" @close="dialogVisible7 = false"></accounts-collection-detail-dialog>
    <!-- <import-all-comp></import-all-comp> -->
    <!-- 申请开票 -->
    <receive-invoice-apply-dialog :model="dialogModel6" v-if="dialogVisible6" @close="dialogVisible6 = false" @success="getTableList"></receive-invoice-apply-dialog>
    <!-- 查看发票信息 -->
    <invoice-bill-msg-dialog :model="invoiceBillMsgModel" v-if="invoiceBillMsgVisible" @close="invoiceBillMsgVisible = false" :invoiceDetail="invoiceDetail"></invoice-bill-msg-dialog>
    <!-- 申请免收 -->
    <approval-dialog v-if="applyFreeVisible" @close="applyFreeVisible = false" :model="applyFreeModel" @success="getTableList"></approval-dialog>
    <!-- 申请开红票(月账单选择) -->
    <invoice-gored-select-dialog :model="dialogModel8" v-if="dialogVisible8" @close="dialogVisible8 = false" @success="onGoRedDialog"></invoice-gored-select-dialog>
    <!-- 申请开红票 -->
    <approval-dialog v-if="dialogVisible10" :model="dialogModel10" @close="dialogVisible10 = false" @success="getTableList"></approval-dialog>
  </div>
</template>

<script>
/** 应收账单 */
import qs from 'qs';
import moment from 'moment';
import apis from '@/utils/apis';
import invoiceBillMsgDialog from '@/pages/fms/components/invoice_bill_msg_dialog';
import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';
import receiveInvoiceApplyDialog from '@/pages/fms/components/receive_invoice_apply_dialog.vue';
import accountsFooterSum from '@/pages/fms/components/accounts_footer_sum.vue';
import invoiceGoredSelectDialog from '@/pages/fms/components/invoice_gored_select_dialog.vue';
import tableFilterValueGetParamMixins from '@/mixins/table_filterValue_getParam_mixins.js';
import accountsRegistrationDialog from '../../components/accounts_registration_dialog';
import accountsCollectionDetailDialog from '../../components/accounts_collection_detail_dialog';
import accountsConfirmDialog from '../../components/accounts_confirm_dialog';
import commonMixin from '../../mixins/commonMixin';
import mixins from '../../components/mixins';
// - 用于调试
const isMock = false;

export default {
  mixins: [commonMixin, mixins, tableFilterValueGetParamMixins],
  components: {
    invoiceGoredSelectDialog,
    invoiceBillMsgDialog,
    approvalDialog,
    accountsRegistrationDialog,
    receiveInvoiceApplyDialog,
    accountsConfirmDialog,
    accountsCollectionDetailDialog,
    accountsFooterSum,
  },
  props: {
    type: [Number, String],
  },
  data() {
    const initBillPaymentTime = [`${this.$moment().format('YYYY-MM-01')} 00:00:00`, `${this.$moment().format('YYYY-MM-DD')} 23:59:59`];

    return {
      invoiceDetail: true,
      cancelRegister: true,
      rejectCollection: true,
      addBill: true,
      delBill: true,
      addTradeMsg: true,
      editTradeMsg: true,
      delTradeMsg: true,
      provide: true,
      dateType: 0,
      tableSelect: [],

      formSearch: {
        receivableOrgType: '',
        initBillPaymentTime: initBillPaymentTime,
        keyword: '',
        bodyNum: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        invoiceNum: '',
        locationName: '',
        payableOrgName: '',
        billPaymentTime: [this.$momentWorld(initBillPaymentTime[0]), this.$momentWorld(initBillPaymentTime[1])],
        finalPaymentTime: '',
        tradeConfirmTime: '',
        // 开票时间
        invoiceTime: '',
        deviceNo: '',
        termNum: '',
        productCode: '',
        invoiceState: '',
        // 业务员
        salesman: '',
        // 最终应收日期
        finalTime: '',
        beginTime: '',
        endTime: '',
      },

      tableList: [],
      totalRows: 0,

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      // 应收管理-确认收款
      dialogVisible3: false,
      dialogModel3: {},
      // 应收管理-登记收款
      dialogVisible4: false,
      dialogModel4: {},
      // 应收管理-收款记录
      dialogVisible5: false,
      dialogModel5: {},
      // 查看收款详情
      dialogVisible7: false,
      dialogModel7: {},
      dialogVisible8: false,
      dialogModel8: {},
      dialogVisible10: false,
      dialogModel10: {},
      link: null,
      totalData: {
        totalPaymentAmount: 0,
      },
      billPaymentTimeKey: 1,
    };
  },
  computed: {
    // 是否变更状态
    isChangeState() {
      return this.tableSelect.length === 1 && (this.tableSelect[0].billTradeState === 0 || this.tableSelect[0].billTradeState === 100) && this.tableSelect[0].bizState === 43;
    },
    // 是否服务公司
    isJVSC() {
      const userInfo = this.$store.state.userInfo || {};
      return userInfo.bizType === 'JV_SC';
    },
    tableCode() {
      const map = {
        1: 'receive_order_wait', // term,deposit,breaks,late_fee,stock,sales_fee,sales_part,sales_data
        2: 'receive_order_received', // term,deposit,breaks,late_fee,stock,sales_fee,sales_part,sales_data
        3: 'receive_order_all', // term,deposit,breaks,late_fee,stock,sales_fee,sales_part,sales_data
      };
      return map[this.type];
    },
    tabList() {
      return [
        {
          name: this.$t('fms_receive_order_item.dai_shou_kuan'),
          value: '1',
        },
        {
          name: this.$t('fms_receive_order_item.yi_shou_kuan'),
          value: '2',
        },
        {
          name: this.$t('Common.com_all'),
          value: '3',
        },
      ];
    },
    // 是否可以申请冲红
    isApplyGoRed() {
      return (
        this.tableSelect.length > 0
        && this.tableSelect.filter((t) => `${t.invoiceStatus}` !== '10' || t.payableOrgId !== this.tableSelect[0].payableOrgId || t.buyerNumber !== this.tableSelect[0].buyerNumber || !t.invoiceNum)
          .length === 0
      );
    },
    isFactory() {
      const userInfo = this.$store.state.userInfo;
      return userInfo.bizType === 'HQ';
    },
    // 是否可以赠送配件
    isAccessory() {
      // 只有选择了租赁账单，且交易状态为 交易完成 才可用
      // 总部 isFactory
      // 租赁账单   billType: 10
      // 交易完成   billTradeState: 10
      // 单选
      const filteredItems = this.tableSelect.filter((item) => `${item.billType}` === '10' && `${item.billTradeState}` === '10');
      // 单选，选择多个账单时不可用
      return this.isFactory && filteredItems.length === 1;
    },
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    this.getDicMap('invoice_state_t', () => {
      this.getTableList();
    });
    // if (this.isJVSC) {
    //   this.formSearch.receivableOrgType = 'JV';
    // }
  },
  methods: {
    // 申请开票
    onInvoiceApply(row) {
      this.dialogModel6 = {
        title: this.$t('Common.com_minxins_apply_invoice'),
        row,
      };
      this.dialogVisible6 = true;
    },
    toContractDetail(row) {
      const { orderId, orderType } = row;
      if (!orderId) {
        this.$message.error(this.$t('fms_receive_order_item.sjycqsgjzd'));
        return;
      }
      const parentPath = this.$route.path;
      this.jump('/contractdetail', {
        contractId: orderId,
        contractClass: orderType,
        parentPath,
      });
    },
    // 确认收款
    onToConfirm({ billData, resData }) {
      this.rejectCollection = !!this.funcView.receive_order_reject_collection;
      this.confirmCollection(billData, this.$t('fms_receive_order_item.que_ren_shou_kuan'), resData);
    },
    // 确认收款
    confirmCol(row) {
      const item = Array.isArray(row) ? row[0] : row;
      const reqDetailUrl = this.getPaymentInfoReqUrl(item);
      if (!reqDetailUrl) {
        this.$message.error(this.$t('fms_receive_order_item.sjycqsgjzd'));
        return;
      }
      this.rejectCollection = !!this.funcView.receive_order_reject_collection;
      this.confirmCollection(row, this.$t('fms_receive_order_item.que_ren_shou_kuan'));
    },
    // 登记收款
    registerCol(row) {
      const item = Array.isArray(row) ? row[0] : row;
      const reqDetailUrl = this.getPaymentInfoReqUrl(item);
      if (!reqDetailUrl) {
        this.$message.error(this.$t('fms_receive_order_item.sjycqsgjzd'));
        return;
      }
      this.cancelRegister = !!this.funcView.receive_order_cancel_register;
      this.addBill = !!this.funcView.receive_order_add_bill;
      this.delBill = !!this.funcView.receive_order_del_bill;
      this.addTradeMsg = !!this.funcView.receive_order_add_trade_msg;
      this.editTradeMsg = !!this.funcView.receive_order_edit_trade_msg;
      this.delTradeMsg = !!this.funcView.receive_order_del_trade_msg;
      this.registerCollection(row, this.$t('fms_receive_order_item.deng_ji_shou_kuan'));
    },
    // 显示规则：billId
    checkInvoiceDetail(row) {
      const billId = row.billId;
      if (!billId) {
        this.$message.error(this.$t('fms_receive_order_item.sjycqsgjzd'));
        return;
      }
      this.invoiceDetail = !!this.funcView.receive_order_inovice_detail;
      this.checkInvoiceBillMsg(row);
    },
    onTabChange(value) {
      this.$emit('tab', value);
    },
    // 查看收款记录
    onCheckCollectionRecords(row) {
      const reqDetailUrl = this.getPaymentInfoReqUrl(row);
      if (!reqDetailUrl) {
        this.$message.error(this.$t('fms_receive_order_item.sjycqsgjzd'));
        return;
      }
      this.dialogModel7 = {
        data: {
          billData: [row],
        },
      };
      this.dialogVisible7 = true;
    },
    // 申请开红票,选择月账单
    onApplyGoRed() {
      this.dialogModel8 = {
        title: this.$t('fms_receive_order_item.xzyzd'),
        billId: this.tableSelect.map((t) => t.billId),
        buyerNumber: this.tableSelect[0]['buyerNumber'],
      };
      this.dialogVisible8 = true;
    },
    // 申请变更状态
    onApplyChangeState() {
      this.dialogModel.type = 'add';
      this.dialogModel.changeType = 'change_bill_trade_state';
      this.dialogModel.row = this.tableSelect[0];
      this.dialogVisible = true;
    },
    // 赠送配件
    onAccessory() {
      // this.jump('/crmStock/freeAccessoriesOrder', { orderGoodsCode: '20240830000051', bizState: 6, action: 'view' });
      this.$showConfirm(this.$t('fms_receive_order_item.nqdyzspjm')).then(() => {
        this.$postJSON(apis.giveawayOrderReceivableCreate, this.tableSelect[0], true).then((res) => {
          // res.data.type 0不符合赠送条件 1已经存在赠送配件单XXXXXXX 2成功创建赠送配件单XXXXXXX
          const tipsArr = [this.$t('fms_receive_order_item.bfhzstj'), this.$t('fms_receive_order_item.yjczzspjd'), this.$t('fms_receive_order_item.cgcjzspjd')];
          // 合同：90001431  机身号：60101901443  账期：5/11
          this.$showConfirm(
            this.$t('fms_receive_order_item.htojshozqoo', [this.tableSelect[0].contractNo,this.tableSelect[0].bodyNum,this.tableSelect[0].termNum,this.tableSelect[0].totalTerm]),
            tipsArr[res.data.msgCode],
            { confirmButtonText: res.data.orderGoodsCode ? this.$t('fms_receive_order_item.ckpszspjd') : this.$t('Common.com_close'), cancelButtonText: res.data.orderGoodsCode ? this.$t('Common.com_close') : null }
          ).then(() => {
            // 跳转赠送配件单
            if (res.data.orderGoodsCode) {
              // 清缓存
              this.clearKeepAlive('freeAccessoriesOrder');
              this.$nextTick(() => {
                this.jump('/crmStock/freeAccessoriesOrder', { orderGoodsCode: res.data.orderGoodsCode, orderGiveawayId: res.data.orderGiveawayId, bizState: res.data.bizState, action: 'view' });
              });
            }
          });
          this.onPageChange({ page: 1 });
        });
      });
    },
    // 冲红申请
    onGoRedDialog: function (row) {
      this.dialogModel10.type = 'add';
      this.dialogModel10.changeType = 'red_application';
      this.dialogModel10.row = row;
      this.dialogVisible10 = true;
    },
    // 延期收款(付款)弹窗
    onDelayDialog: function (row) {
      const rows = Array.isArray(row) ? row : [row];
      // 添加账单有用
      rows.forEach((item) => {
        item.paymentOrReceivable = false;
      });
      const item = rows[0];
      this.dialogModel.type = 'add';
      this.dialogModel.changeType = 'deferred';
      this.dialogModel.changeId = item ? item.changeId : '';
      this.dialogModel.row = rows;
      this.dialogModel.title = this.$t('fms_receive_order_item.sqyqfk');
      this.dialogVisible = true;
    },
    // 撤销收款弹窗 调用条件： row.changeId || row.billId || row.paymentId
    onRevokeDialog: function (row) {
      if (row.changeId || row.billId || row.paymentId) {
        this.dialogModel.type = 'add';
        this.dialogModel.changeType = 'withdrawal_payment';
        this.dialogModel.changeId = row.changeId;
        this.dialogModel.row = row;
        this.dialogVisible = true;
      } else {
        this.$message.error(this.$t('fms_receive_order_item.sjycqsgjzd'));
      }
    },
    // 导出
    async exportTable() {
      const tableList = this.tableList;
      if (!tableList.length) {
        this.$message.error(this.$t('fms_receive_order_item.wsjkydc'));
        return;
      }
      const reqListData = this.getReqListData();
      const param = {};
      Object.keys(reqListData).forEach((key) => {
        const val = reqListData[key];
        if (val) {
          param[key] = val;
        }
      });

      delete param.pageSize;
      delete param.pageNum;

      const pathParms = qs.stringify(param, { arrayFormat: 'repeat' });

      const headerList = [...this.tableColumn];

      const termNumIndex = headerList.findIndex((item) => item.columnCode === 'termNum');
      const termNumItem = headerList[termNumIndex];
      // 按照文档要求，修改文本
      termNumItem.columnName = this.$t('fms_receive_order_item.qi_hao');

      // 文档要求，加入总期数
      headerList.splice(termNumIndex + 1, 0, {
        columnCode: 'totalTerm',
        columnName: this.$t('fms_receive_order_item.zong_qi_shu'),
        width: 140,
      });

      const date = new Date();
      const fileName = this.$t('fms_receive_order_item.ying_shou_zhang_dan');
      const exportName = `${fileName}_${moment(date).format('YYYYMMDDHHmmss')}`;

      const reqData = {
        exportName: exportName,
        headerList: headerList,
      };

      this.$showLoading();
      try {
        await this.$exportFliePost(`${apis.billOrderTermReceivableExport}?${pathParms}`, reqData);
      } catch (e) {
        this.$message.error(e.message || e.msg || this.$t('fms_receive_order_item.dao_chu_shi_bai'));
      }
      this.$closeLoading();
    },
    // 表格列中，如本期应收金额需要计算，故再此格式化
    formatList(list) {
      const arr = list || [];
      /** 本期应收租金 paymentAmount
本期应收违约金 breakAmount
本期应收逾期费 overdueAmount */
      arr.forEach((item) => {
        const { paymentAmount = 0, breakAmount = 0, overdueAmount = 0 } = item;
        const depositFee = item.termNum === 1 && item.receivableOrgType !== 'SC' ? item.depositFee || 0 : 0;

        const termShouldReceive = paymentAmount + breakAmount + overdueAmount + depositFee;
        item.termShouldReceive = termShouldReceive;

        if (isMock) {
          item.orderId = '';
          item.paymentCode = '';
          item.billPaymentCode = '';
          item.billPaymentId = '';
          item.paymentId = '';
          item.billId = '';
          item.changeId = '';
        }
      });
      return list;
    },
    getReceivableTotal(reqData) {
      const rData = reqData || this.getReqListData();
      // billOrderTermReceivableTotal
      this.$getJSON(apis.billOrderTermReceivableTotal, rData).then((res) => {
        this.totalData = res.data || {};
      });
    },
    // 获取表格数据
    getTableList: function () {
      const deviceNo = this.formSearch.deviceNo;
      const deviceNoStr = `${deviceNo}`;
      const termNum = this.formSearch.termNum;
      // 是否为纯数字的字符串
      const testPureNum = /^\d+$/;
      // 是否为 1-3 格式的字符串
      const testRangeNum = /^\d+\-\d+$/;
      if (deviceNoStr.length > 3) {
        this.$message.error(this.$t('fms_receive_order_item.sbhcdbndy3'));
        return;
      }
      if (termNum) {
        const isPureNum = testPureNum.test(termNum);
        const isRangeNum = testRangeNum.test(termNum);
        if (!isPureNum && !isRangeNum) {
          this.$message.error(this.$t('fms_receive_order_item.qsrhfqh'));
          return;
        }
      }
      const url = apis.billOrderReceivePage;
      const reqData = this.getReqListData();
      this.$getJSON(url, reqData).then((res) => {
        this.tableList = this.formatList(res.data.records);
        this.totalRows = res.data.total;
      });
      this.getReceivableTotal(reqData);
    },
    getReqListData() {
      const sortTypeMap = {
        1: 1,
        2: 0,
        3: 2,
      };
      const billTradeStateMap = {
        1: [0, 1, 2, 6],
        2: [10, 11, 90, 100],
        3: [],
      };
      const ret = {
        ...this.formSearch,
        beginTime: this.formSearch.finalTime ? this.formSearch.finalTime[0] : '',
        endTime: this.formSearch.finalTime ? this.formSearch.finalTime[1] : '',
        sortType: sortTypeMap[this.type],
      };

      if (ret.billTradeState === undefined || ret.billTradeState === '' || !ret.billTradeState.length) {
        /*
        待收款（0-未交易，1-正在交易，2-免收中，6-待确认收款）
        已收款（10-交易完成，11-免收完成，90-交易拒绝，100-交易关闭）
        全部（6-待确认收款，2-免收中，1-正在交易，0-未交易，10-交易完成，11-免收完成，90-交易拒绝，100-交易关闭）
        */
        ret.billTradeState = billTradeStateMap[this.type];
      }

      if (ret.termNum) {
        ret.termNum = this.formatTermNum(ret.termNum);
      }

      return this.appendReqListData(ret, 'receive_order');
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.$refs.customTb1.clearFilter();
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.formSearch.billPaymentTime = '';
      // 然后日期组件重新根据init-value赋值
      this.billPaymentTimeKey++;
      setTimeout(() => {
        this.onPageChange({ page: 1 });
      }, 300);
    },
  },
};
</script>

<style lang="scss">
.receive-order-item {
  // display: flex;
  // flex-direction: column;
  // height: 100%;
  .tab {
    margin-left: -16px;
    margin-right: -16px;
  }

  .half-content {
    width: 25%;
    display: inline-block;
  }

  .half-width {
    width: 50% !important;
  }

  .underline {
    color: #0d9ae0;
    text-decoration: underline;
    cursor: pointer;
  }

  .sum-params {
    float: left;
    overflow: hidden;

    .selected-num {
      padding: 0 5px;
      color: #0d9ae0;
    }
    .sum,
    .price {
      color: #0d9ae0;
    }

    .ml-10 {
      margin-left: 10px;
    }

    .sum-item {
      float: left;
      line-height: 32px;
      font-size: 12px;
      color: #606266;
      .key,
      .val {
        float: left;
      }
    }
  }
}
</style>
